module.exports = __webpack_public_path__ + "img/icon117.1fb9dcff.png";